import React, { forwardRef } from 'react';
import { CardMedia, useTheme } from '@mui/material';
import { COLLECTION_COVER_BORDER_RADIUS } from './consts';

const DSCollectionCardMedia = forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof CardMedia>
>((props, ref) => {
  const { palette } = useTheme();
  return (
    <CardMedia
      ref={ref}
      {...props}
      sx={{
        ...props.sx,
        width: '100%',
        aspectRatio: '1',
        borderRadius: COLLECTION_COVER_BORDER_RADIUS,
        backgroundColor: props.image
          ? 'transparent'
          : palette.action.disabledBackground,
      }}
    />
  );
});

export default DSCollectionCardMedia;
